/**
 * Отложенный вызов: срабатывает через waitMs после последнего обращения. cancel() сбрасывает ожидание.
 */
export const debounce = (fn, waitMs) => {
    let timer = null;

    const debounced = (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), waitMs);
    };
    debounced.cancel = () => clearTimeout(timer);

    return debounced;
};
